import { Tooltip } from "@mui/material";

export function ExceptionButtonSelfApprovalTooltipWrapper({
  exceptionsAllowSelfApproval,
  children,
}: {
  children: React.ReactNode;
  exceptionsAllowSelfApproval: boolean;
}) {
  return (
    <Tooltip
      title={
        !exceptionsAllowSelfApproval
          ? "Self approval of exceptions is disabled for this space"
          : ""
      }
      arrow
      placement="top"
    >
      <span>{children}</span>
    </Tooltip>
  );
}
